export default __webpack_public_path__ + "locales/lv/EmptyView.json?hash=7c0c260083af419681de94d840a4ba77";